<template>
  <div id="login" :style="{ '--text-color': 'black' }">
    <div id="main">
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          height: 100vh;
          overflow-y: hidden;
        "
      >
        <vue-particles
          color="#ffffff"
          :particle-opacity="0.27"
          :particles-number="24"
          shape-type="circle"
          :particle-size="3"
          lines-color="#ffffff"
          :lines-width="1.1"
          :line-linked="true"
          :line-opacity="0.33"
          :lines-distance="192"
          :move-speed="1.6"
          :hover-effect="false"
          :click-effect="false"
        ></vue-particles>
      </div>

      <div style="position: relative">
        <div v-show="error" class="alert-danger alert-header">
          <v-container style="padding-top: 10px; padding-bottom: 10px">
            <v-layout wrap>
              <v-flex xs10 sm11>
                <v-layout>
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/warning.svg'"
                    width="30px"
                    height="auto"
                    class="icon mr-2 mt-2"
                  />
                  <div class="pt-2 pl-2">{{ error }}</div>
                </v-layout>
              </v-flex>
              <v-flex xs2 sm1 class="text-xs-right">
                <v-btn dark flat fab small class="ma-0" @click="error = undefined">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <!-- v-if="error" -->

        <div class="container">
          <br />
          <div class="text-xs-center">
            <v-layout wrap>
              <v-flex xs12 sm8 md6 xl4 offset-sm2 offset-md3 offset-xl4>
                <img
                  class="brand responsive-img"
                  :src="$store.state.theme.logo"
                  alt="zwiz.ai"
                  style="margin: 35px auto; width: auto; max-width: 100%"
                />
                <form @submit.prevent>
                  <div
                    class="form-control text-xs-left"
                    :class="{ 'has-error': errors.has('username') }"
                  >
                    <div class="input-username form-group">
                      <label for style="color: var(--text-color)">Username</label>
                      <input
                        id="inputUserid1"
                        v-model="userid"
                        v-validate="'required'"
                        type="text"
                        class="input form-control"
                        aria-describedby="userid"
                        placeholder="User ID"
                        data-vv-as="Username"
                        data-vv-name="username"
                      />
                    </div>
                    <span v-show="errors.has('username')" class="text-error">{{
                      errors.first('username')
                    }}</span>
                  </div>

                  <div
                    class="form-control text-xs-left"
                    :class="{ 'has-error': errors.has('password') }"
                  >
                    <div class="input-password form-group">
                      <label for style="color: var(--text-color)">Password</label>
                      <input
                        id="password"
                        v-model="password"
                        v-validate="'required'"
                        type="password"
                        class="input form-control"
                        placeholder="Password"
                        data-vv-as="Password"
                        data-vv-name="password"
                        @keyup.enter="$refs.loginbtn.$el.click()"
                      />
                    </div>
                    <span v-show="errors.has('password')" class="text-error">{{
                      errors.first('password')
                    }}</span>
                  </div>

                  <vue-recaptcha
                    ref="recaptcha"
                    :key="`recaptcha_${timestamp}`"
                    sitekey="6Lc60GQUAAAAAMhf0gyvGKZMiDeOTbns-UbJpTcc"
                    @verify="loginByUsername"
                    @expired="onExpired"
                  >
                    <v-btn
                      ref="loginbtn"
                      depressed
                      color="primary"
                      style="margin-top: 20px; margin-left: 0; width: 100%"
                      >Sign In with Account</v-btn
                    >
                  </vue-recaptcha>
                </form>
                <p style="color: var(--text-color); margin-top: 45px">
                  Powered by Robolingo Co., Ltd.
                </p>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </div>
    <modal-dialog v-if="false" @close="error = undefined">
      <div slot="body" class="text-xs-center" style="margin-top: 25px">
        <img src="/static/img/assets/login/alert.png" alt class="responsive-img" />

        <h1>Error</h1>
        <p>
          <nl2br tag="span" :text="error" />
        </p>
      </div>
      <div slot="footer" class="text-xs-center" style="padding: 15px">
        <v-btn dark flat fab small class="ma-0" @click="error = undefined">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </modal-dialog>

    <a
      href="https://enterprise-cms.s3.ap-southeast-1.amazonaws.com/prolicy/policy_robolingo_2566.pdf"
      target="_blank"
    >
      <div
        class="text-xs-center"
        style="position: absolute; bottom: 0; left: 0; right: 0; padding: 10px"
      >
        <span style="color: var(--text-color)">{{ $t('privacy_policy') }}</span>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import Nl2br from 'vue-nl2br'
import moment from 'moment'
import trueidApi from '@/api/trueid'
import stateConfig from '@/store/config'
import { getPage } from '@/config/customize'

export default {
  name: 'LoginView',
  components: {
    VueRecaptcha,
    Nl2br
  },
  data: function () {
    return {
      userid: '',
      password: '',
      error: null,
      recaptcha: undefined,
      timestamp: moment().format('x'),
      loginType: undefined,
      warroomToken: undefined,
      warroomConfig: { appType: 'taskpane', appId: 'demo#8251' }
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  },
  async created() {
    if (this.$localStorage.get('app_type') === 'warroom') {
      this.$localStorage.remove('app_type')
    }
    this.loginType = this.$route.query.apptype || undefined
    if (this.loginType == 'warroom') {
      // eslint-disable-next-line no-undef
      const appStatus = await warroom.init(this.warroomConfig)
      if (appStatus) {
        // eslint-disable-next-line no-undef
        this.warroomToken = warroom.token
        // auto login here
        try {
          const response = await trueidApi.postAutoLogin({
            data: {
              token: this.warroomToken
            }
          })

          if (response && response.data) {
            this.$localStorage.set('app_type', 'warroom')
            await this.$store.dispatch('setAccountSession', { ...response.data })
            this.$store.commit(stateConfig.LOGIN_SUCCESS)

            const bot = this.$store.getters.botlist.find((el) =>
              ['trueid'].includes(getPage(el.pageid))
            )
            if (bot) {
              this.$store.dispatch('selectBot', bot)
              this.$router.push({ name: 'system-maintenance', query: {} })
            } else {
              this.$router.push('/' + this.currentLang)
            }
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
  },
  mounted: function () {
    var vm = this
    vm.$validator.localize(vm.currentLang)
    vm.$store.dispatch('logout', null).then(function () {})
    vm.$nextTick(function () {
      vm.$store.commit('CLEAR_LOADING')
    })
    if (vm.$store.state.systemError && vm.$store.state.systemError.message) {
      vm.error = vm.$store.state.systemError.message
    }
  },
  methods: {
    initReCaptcha: function () {},
    onSubmit: function (token) {
      var vm = this

      try {
        vm.$store
          .dispatch('login', {
            userid: vm.userid,
            password: vm.password,
            'g-recaptcha-response': token,
            offset: 0,
            pagename: ''
          })
          .then(
            function () {
              if (vm.$route.query && vm.$route.query.tab == 'ceemeagain') {
                var bot = vm.$store.getters.botlist.find((el) => el.pageid == '109547317606650')
                vm.$store.dispatch('selectBot', bot)
                vm.$router.push({ name: 'dashboard', query: { tab: 'ceemeagain' } })
              }
              // ขอเก็บโค๊ดชุดนี้ไว้ก่อน เผื่อใช้จ้า
              // else if (vm.userid.includes('com7')) {
              //   var bot = vm.$store.getters.botlist.find(
              //     el => el.pageid == vm.$store.state.com7pages[0].pageid
              //   )

              //   if (vm.$route.query.redirect) {
              //     vm.$store.dispatch('selectBot', bot)
              //     vm.$router.push({ path: vm.$route.query.redirect })
              //   } else if (['agent', 'superadmin'].includes(vm.$store.state.privilege.role)) {
              //     vm.$store.dispatch('selectBot', bot)
              //     vm.$router.push({ name: 'ticket2profile' })
              //   } else {
              //     vm.$router.push('/' + vm.currentLang)
              //   }
              // }
              else {
                if (vm.$route.query.redirect) {
                  // parse redirect url to params
                  const url = new URLSearchParams(vm.$route.query.redirect)
                  const pageid = url.get('pageid')
                  const bot = vm.$store.getters.botlist.find((el) => el.pageid == pageid)
                  if (bot) {
                    vm.$store.dispatch('selectBot', bot)
                    window.location.href = vm.$route.query.redirect
                  } else {
                    vm.$router.push('/' + vm.currentLang)
                  }
                } else {
                  vm.$router.push('/' + vm.currentLang)
                }
              }
            },
            function (error) {
              // console.log(error)
              vm.error = error.message
              vm.resetRecaptcha()
            }
          )
      } catch (error) {
        // console.log(error)
      }
    },
    loginByUsername: function (response) {
      let vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          vm.resetRecaptcha()
          return false
        }
        vm.$refs.recaptcha.execute()
        vm.onSubmit(response)
      })
    },
    onSignInError(error) {
      var vm = this
      vm.error = error.message
      vm.resetRecaptcha()
    },
    onExpired: function () {},
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
      this.timestamp = moment().format('x')
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/login/Nigol.vue